import videoplayer from './sub/videoplayer';
import audioplayer from './sub/audioplayer';
import lightOrDarkImage from '@check-light-or-dark/image';

export default class guide {
  constructor() {
    this.fixplays = $('.fixplay');

    window.audios = [];

    new videoplayer();

    this.inits = this.inits.bind(this);
    this.binds = this.binds.bind(this);
    this.bindScroll = this.bindScroll.bind(this);
    this.loadAnim = this.loadAnim.bind(this);

    this.inits();
    this.binds();
    this.bindScroll();
    this.loadAnim();
    // var t = this;
    // window.onpageshow = function(){ t.loadAnim(); }
  }

  inits() {
    $('.clouds img').each(function(idx){
      var x = Math.random()*100 + '%';
      var y = 100 * (idx/$('.clouds img').length) + '%';
      $(this).css({
        'top' : y,
        'left' : x,
      });
    });

    $('.textpage-link').unbind('click').click(function(e){
      if(window.allowDomeClick){
        window.allowDomeClick = false;

        e.stopPropagation();
        e.preventDefault();
        let href = $(this).attr('href');
        $('.pop').remove();
        $('body').append('<div class="pop"><a href="#" class="pop--close"></a><div class="pop--content"></div></div>')
        $('html').addClass('pop-open');
        $.get(href, function(data){
          // console.log(data);
          var html = $(data).find('.guide-subpage').parent().html();
          $('.pop--content').html(html);
          $('html').removeClass('show-header');
          $('.pop').fadeIn(200);
          window.allowDomeClick = true;
        });

        $('.pop--close').unbind('click').on('click', function(e){
          e.stopPropagation();
          e.preventDefault();
          $('html').removeClass('pop-open');
          $('html').addClass('show-header');
          $('.pop').fadeOut(200, function(){
            $('.pop').remove();
          });
        });
      }
    });

    if($('.darkhero').length==0) {
      if($('.opener .bg').length>0){
        lightOrDarkImage({
          image: $('.opener .bg').attr('src')
        }).then(res => {
          if(res=='dark') {
            $('html').addClass('hero-dark');
          } else {
            $('html').removeClass('hero-dark');
            // console.log('hero bg is ',res);
          }
        });
      }
    } else {
      $('html').addClass('hero-dark');
    }
  }

  loadAnim() {
    var parent = this;

    $('.clouds img').each(function(idx){
      $(this).css('opacity',1);
      // $(this).animate({
      //   'opacity': 1,
      // }, 1500);
      var cloud = this;

      if(idx%2==0) {
        $(cloud).addClass('anim-left');
      } else {
        $(cloud).addClass('anim-right');
      }

      if($('.slide-wip').length==0) {
        $('.slide-0 .bg').css('opacity', 1);
        if($('.slide-0 video.bg').length>0){
          $('.slide-0 video.bg').get(0).play();
        }

        setTimeout(function(){
          $(cloud).addClass('out');

          if(idx >= $('.clouds img').length-1) {
            $('.slide-0 .logo').addClass('slow').css('opacity', 0);
            $('.scroll').removeClass('out');
            $('html').addClass('show-header');
          }
        }, 800 + (1200/$('.clouds img').length) * idx);
      }
    });

    $('h3 span').addClass('anim');

    $('.slide-0 .logo').css('opacity', 1);
    $('.slide-0 h3').css('opacity', 1);


    // $(window).on('load', function(){
    if($('.slide-0 video').length>0){
      $('.slide-0 video').get(0).play();
    }
  

      $('.fixplay').each(function(){
        this.vid = $(this).children('video');
        if(this.vid) {
          let myVid = this.vid.get(0);
          if(myVid) {
            let theSrc = $(this.vid).attr('data-src');
            // this.src = theSrc;

            this.progressbar = $(this).find('.progress--bar');

            myVid.addEventListener('seeking', function() {
              this.isSeeking = true;
            });

            myVid.addEventListener('seeked', function() {
              this.isSeeking = false;
            });

            // if(!this.requestSent){
              this.requestSent = true;
              var r = new XMLHttpRequest();
              r.onload = function() {
                console.log('loaded');
                myVid.src = URL.createObjectURL(r.response);
                myVid.play();
                setTimeout(function(){
                  $(myVid).removeAttr('data-src');
                  myVid.pause();
                  myVid.currentTime = 0.01;
                }, 200);
              };
              r.open("GET", theSrc);
              r.responseType = "blob";
              r.send();
            // }
          }
        }
      });
      

      /*
        console.log('winloaded, loading videos');
        for(var i=0;i<parent.fixplays.length;i++){
          let video = parent.fixplays[i].vid.get(0);
          video.addEventListener('loadeddata', function() {
            console.log('video loaded:',this);
            $(video).removeAttr('data-src');
          }, false);
          // $(video).attr('preload', 'auto');
          setTimeout(function(){
            video.load();
          },1000);
        }
        */
    // });
  }

  binds() {
    $('.nav--items a').click(function(e){
      var href = $(this).attr('href');
      $('html,body').animate({
        'scrollTop' : $(href).position().top
      }, 400);
      if(!$(href).hasClass('open')){
        $(href).find('h1.exp').click();
      }
      $('html').removeClass('nav-open');

    });

    $('.content-slide h1.exp').click(function(){
      $(this).parent('.content-slide').toggleClass('open');
      $(this).siblings('.content-slide--content').slideToggle(300);
      $(window).trigger('scroll');

      if($(this).parent('.content-slide').hasClass('open')){
        $(this).parent('.content-slide').find('audio[data-src]:not([src])').each(function(){
          $(this).attr('src', $(this).attr('data-src'));
        });
      }
    });

    $('.audioblock').each(function(){
      window.audios.push(new audioplayer(this));
    });
  }

  bindScroll() {
    var self = this;
    $(window).scroll(function(){
      let winH = window.innerHeight;
      if($(window).scrollTop()>5) {
        $('.scroll').addClass('out');
      } else {
        $('.scroll').removeClass('out');
      }

      if($('.slide-0').get(0).getBoundingClientRect().bottom < 50) {
        $('.hero-dark').removeClass('hero-dark').addClass('hero-was-dark');
      } else {
        $('.hero-was-dark').addClass('hero-dark');
      }

      $(self.fixplays).each(function(){
        let h = $(this).outerHeight();
        let btm = this.getBoundingClientRect().bottom;
        var prc = 1 - ((btm-winH)/(h-winH));
        if(prc <= 1 && prc >= 0){
          let vid = this.vid[0];
          // console.log(prc, vid.duration);
          let pos = prc * vid.duration;
          if(!vid.isSeeking) {
            vid.currentTime = pos;
          }

          $(this.progressbar).css('width',prc*100+'%');
        }
      });

      $('.content-slide video:not(.fixplayvid)').each(function(){
        let rect = this.getBoundingClientRect();
        if(rect.top < window.innerWidth && rect.bottom > 0) {
          if(this.paused){
            this.play();
            // if(!this.muted) {
              // $(this).animate({'volume' : 1}, 200);
            // }
          }
        } else {
          // not in view
          if(!this.paused) {
            this.pause();
          }
          // if(!this.paused) {
            // if(!this.muted) {
              // $(this).animate({'volume' : 0}, 200, function(){
                // this.pause();
              // });
            // } else {
              // this.pause();
            // }
          // }
        }
      });
    });
  }

}
